$('#add-primary').on 'click', (event) ->
	event.preventDefault()
	$.ajax
		url: '/self-enrollment/primary/create/'
		data: {
			id: $(this).data('eid')
		},
		method: 'GET',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			$('#primary-form-wrapper').show()
			$('#primary-form-wrapper').html html
			$('#add-primary').hide()
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred getting primary form.'

$('#primary-form-wrapper').on 'change', '#participant-billingissameasmailing, #participantenrollmentform-billingissameasmailing', (event) ->
	if $('#participant-billingissameasmailing, #participantenrollmentform-billingissameasmailing').prop('checked')
		$('#billing-address-fields').hide();
		$('#billing-address-fields').find('input').val '';
		$('#billing-address-fields').find('input').prop 'disabled', true;
	else
		$('#billing-address-fields').find('input').prop 'disabled', false;
		$('#billing-address-fields').find('input').val '';
		$('#billing-address-fields').show();

$('#primary-form-wrapper').on 'submit', '#primary-form', (event) ->
	event.preventDefault()
	$.ajax
		url: $('#primary-form').attr('action'),
		data: $('#primary-form').serialize(),
		method: 'POST',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			if jqXHR.status == 201
				# Primary created/updated successfully, so we can allow dependents to now be added.
				$('#add-dependent').prop 'disabled', false
				$('#code-alert-primary').remove()
				enableSaveAndContinue()
			$('#primary-form-wrapper').html html
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred submitting primary form.'

$('#primary-form-wrapper').on 'click', '#edit-primary', (event) ->
	event.preventDefault()
	$.ajax
		url: '/self-enrollment/primary/update/'
		data: {
			id: $(this).data('eid')
		},
		method: 'GET',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			$('#primary-form-wrapper').html html
			disableSaveAndContinue()
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred getting primary update form.'


$('#primary-form-wrapper, #dependent-view-wrapper').on 'click', '.expand-view-btn', (event) ->
	$(this).find('i').toggleClass 'fa-caret-down fa-caret-up'

$('#add-dependent').on 'click', (event) ->
	event.preventDefault()
	if $('.dependent-view-card').length == 0
		position = 0
	else
		position = $('.dependent-view-card:last-child').data('position') + 1
	$.ajax
		url: '/self-enrollment/dependent/create/'
		data: {
			id: $(this).data('eid'),
			position: position,
		},
		method: 'GET',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			$('#dependent-form-wrapper').show()
			$('#dependent-form-wrapper').append html
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred getting dependent form.'

$('#dependent-form-wrapper').on 'submit', '#dependent-form', (event) ->
	event.preventDefault()
	position = $(this).data 'position'
	$.ajax
		url: $('#dependent-form').attr('action'),
		data: $('#dependent-form').serialize(),
		method: 'POST',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			if jqXHR.status == 201
				# Dependent created successfully, so we can allow dependents to now be added.
				enableSaveAndContinue()
				$('#dependent-form-wrapper').empty()
				$('#dependent-view-wrapper').show()
				$('#code-alert-dep-' + position).remove()
				if $('#dependent-view-' + position).length > 0
					# This is the update scenario - we need to update, not add a new view card.
					$('#dependent-view-' + position).replaceWith html
				else
					$('#dependent-view-wrapper').append html
			else
				$('#dependent-form-wrapper').html html
				$('.dependent-form-card').addClass 'border-warning'
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred submitting primary form.'

$('#dependent-view-wrapper').on 'click', '.edit-dependent', (event) ->
	event.preventDefault()
	position = $(this).data 'position'
	dependentViewSelector = '#dependent-view-' + position
	$.ajax
		url: '/self-enrollment/dependent/update/'
		data: {
			id: $(this).data('eid'),
			position: position
		},
		method: 'GET',
		cache: false,
		success: (html, textStatus, jqXHR) ->
			$(dependentViewSelector).css 'pointer-events', 'none'
			$(dependentViewSelector).addClass 'border-warning'
			$('#dependent-form-wrapper').show()
			$('#dependent-form-wrapper').html html
			$('.dependent-form-card').addClass 'border-warning'
		error: (jgXHR, textStatus, errorThrown) ->
			console.log 'An unexpected error occurred getting primary update form.'

$('#dependent-form-wrapper').on 'click', '.dependent-form-close', (event) ->
	event.preventDefault()
	$('#dependent-form-wrapper').empty()
	$('.dependent-view-card').css 'pointer-events', ''
	$('.dependent-view-card').removeClass 'border-warning'

$('#dependent-view-wrapper').on 'click', '.remove-dependent', (event) ->
	event.preventDefault()
	position = $(this).data 'position'
	confirmation = confirm 'Are you sure you want to remove this dependent?'
	if confirmation
		$.ajax
			url: '/self-enrollment/dependent/delete/'
			data: {
				id: $(this).data('eid'),
				position: position
			},
			method: 'POST',
			cache: false,
			success: (json, textStatus, jqXHR) ->
				if json.success == 1
					$('#dependent-view-' + position).remove()
			error: (jgXHR, textStatus, errorThrown) ->
				console.log 'An unexpected error occurred getting primary update form.'

enableSaveAndContinue = ->
	$('#enroll-save-and-continue').removeClass 'disabled'
	$('#enroll-save-and-continue').attr 'aria-disabled', 'false'
	$('#enroll-save-and-continue').attr 'tabIndex', '0'

disableSaveAndContinue = ->
	$('#enroll-save-and-continue').addClass 'disabled'
	$('#enroll-save-and-continue').attr 'aria-disabled', 'true'
	$('#enroll-save-and-continue').attr 'tabIndex', '-1'

$(document).on 'change', '#mandatedDateRanges', ->
  selectedOption = $(@).find ':selected'
  start = selectedOption.data 'start'
  end = selectedOption.data 'end'
  isReadOnly = selectedOption.data 'readonly'

  $('input[name="ParticipantEnrollmentForm[start_date]"]')
    .prop
      readonly: isReadOnly
      value: start
    .trigger 'change'

  $('input[name="ParticipantEnrollmentForm[end_date]"]')
    .prop
      readonly: isReadOnly
      value: end
    .trigger 'change'

$(document).on 'change', '.startdate,.enddate', ->
  if $('.startdate.fixedInterval').length > 0
    return null
  start = new Date $('.startdate').val()
  end = new Date $('.enddate').val()
  if not start? or not end? then return null
  oneDay = 1000*60*60*24
  if start.getTime() == end.getTime() then return 0
  $('.count_display').find('.day-count').html Math.round((end.getTime() - start.getTime()) / oneDay) + 1
